import {IComponent, IComponentEmpty, IComponentTab, IComponentCommentSend, IComponentCommentList, IComponentNavigator} from '../../component.d';
import {IPageDetail, IConfigDetail} from '../../global.d';
import {getPageSameType, updatePageById} from '../../utils/util';

export const videoTypeTransformer = (pageDetail:IPageDetail, configDetail:IConfigDetail)=>{
  // 布局图
  // 头部导航条
  // 空容器
  // --> 视频组件 / 如果没有视频组件，但拥有一个头图组件，也适用的 -- 2023-05-30
  // --> 空容器
  //      --> 评论列表
  //      --> 评论发送
  // --> 余下的组件
  let newTemplate = [] as IComponent[];
  console.log(window.pageDetail.template);
  let usedMap = {} as {
    [key:string]:boolean
  };
  let navigator = pageDetail.template.find((it:IComponent)=>it.type == 'navigator');
  if(navigator) {
    newTemplate.push({
      ...navigator,
      // @ts-ignore
      find:false,
      // @ts-ignore
      my:false,
      // @ts-ignore
      useLocalDom:true
    });
    usedMap[navigator.cid] = true;
  }
  let video = pageDetail.template.find((it:IComponent)=>it.type == 'videoh');
  let commentlist = pageDetail.template.find((it:IComponent)=>it.type == 'commentlist');
  let commentsend = pageDetail.template.find((it:IComponent)=>it.type == 'commentsend');
  let pendent = pageDetail.template.find((it:IComponent)=>it.type == 'pendent');

  let empty = {
    type:'empty',
    direction:'row',
    cid:'empty',
    list:[] as IComponent[],
    container:{
      bottom:0,
      top:0,
      left:0,
      right:0
    }
  } as IComponentEmpty;

  let videoEmpty = {
    type:'empty',
    direction:'column',
    cid:'video_empty',
    list:[] as IComponent[],
    container:{
      bottom:0,
      top:0,
      left:0,
      right:0
    }
  } as IComponentEmpty;
  if(video) {
    videoEmpty.list!.push({
      ...video
    });
    usedMap[video.cid] = true;
  }else {
    // 同样的位置，有没有一个头图组件
    let head = pageDetail.template.find((it:IComponent)=>it.type == 'slidehead');
    if(head) {
      videoEmpty.list!.push({
        ...head
      });
      usedMap[head.cid] = true;
    }
  }
  if(pendent) {
    videoEmpty.list!.push({
      ...pendent,
      // @ts-ignore
      useLocalDom:true,
      container:{
        ...pendent.container,
        top:20,
        left:10,
        bottom:17,
        right:10
      }
    });
    usedMap[pendent.cid] = true;
  }
  empty.list!.push(videoEmpty);

  let commentEmpty = {
    type:'empty',
    direction:'column',
    cid:'comment_empty',
    list:[] as IComponent[],
    container:{
      bottom:0,
      top:0,
      left:0,
      right:0,
      paddingTop:10,
      paddingLeft:10,
      paddingRight:10
    }
  } as IComponentEmpty;

  let useRightComment = !!commentlist;
  if(!commentlist) {
    // 都没有找到的情况下，要去看一下，是不是都在某个Tab组件里
    let tab = getPageSameType(pageDetail.template, [], 'tab');
    let flag = false;
    for(var i=0;i<tab.length;i++) {
      let one = tab[i] as IComponentTab;
      let list = one.list;
      if(list && list.length) {
        for(var j=0;j<list.length;j++) {
          let one_tab = list[j] as any;
          let tab_commentlist = (one_tab.children || []).find((it:IComponent)=>it.type == 'commentlist');

          if(tab_commentlist) {
            flag = true;
            commentlist = tab_commentlist;

            let tab_commentsend = (one_tab.children || []).find((it:IComponent)=>it.type == 'commentsend');

            if(tab_commentsend) {
              commentsend = tab_commentsend;
              // 移除当前的tab
              // @ts-ignore
              list[j] = null;
            }
          }
        }
      }

      list = list.filter(Boolean);
      // @ts-ignore
      tab[i].list = list;
      updatePageById(pageDetail.template, tab[i].cid, tab[i]);
    }

    if(flag) {
      useRightComment = true;
    }
  }

  if(useRightComment) {
    if(commentlist) {
      commentEmpty.list!.push({
        ...commentlist,
        theme:'list',
        container:{
          top:0,
          left:0,
          right:0,
          bottom:0
        }
      } as IComponentCommentList);
      usedMap[commentlist.cid] = true;
    }
    if(commentsend) {
      commentEmpty.list!.push({
        ...commentsend,
        renderMode:'pc'
      } as IComponentCommentSend);
      usedMap[commentsend.cid] = true;
    }
    empty.list!.push(commentEmpty);
  }

  newTemplate.push(empty);

  pageDetail.template.forEach((it:IComponent)=>{
    if(!usedMap[it.cid]) {
      newTemplate.push({
        ...it
      });
    }
  });

  console.log(newTemplate);

  window.configDetail.use_face = 0;

  return newTemplate;
};
